var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "contents" } },
    [
      _c("div", { staticClass: "company-area no-top" }, [
        _vm.companyInfo.name
          ? _c(
              "h1",
              {
                staticClass: "company-title",
                attrs: { "data-test": "company-name" },
              },
              [_vm._v("\n      " + _vm._s(_vm.companyInfo.name) + "\n    ")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.isLightPlan
        ? [
            _c("div", { staticClass: "contents-inner" }, [
              _vm.companyInfo.catchCopy
                ? _c(
                    "p",
                    {
                      staticClass: "large-text taL fwB",
                      attrs: { "data-test": "catch" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.companyInfo.catchCopy) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contents-inner" }, [
              _c("p", { staticClass: "taC mt15" }, [
                _vm.companyInfo.introImage && _vm.companyInfo.introImage.id
                  ? _c("img", {
                      staticClass: "company-img-main image-height-auto",
                      attrs: {
                        src: _vm.getPhotoUrl(_vm.companyInfo.introImage),
                        alt: _vm.companyInfo.name,
                        "data-test": "company-img-intro",
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.companyInfo.introText
                ? _c("p", {
                    staticClass: "mt15 pega-pre-wrap",
                    attrs: { "data-test": "introText" },
                    domProps: {
                      textContent: _vm._s(_vm.companyInfo.introText),
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("company-preview-images-sp", {
              attrs: { "company-info": _vm.companyInfo },
            }),
            _vm._v(" "),
            _vm.report.body
              ? _c(
                  "div",
                  {
                    staticClass: "view-point",
                    attrs: { "data-test": "viewpoints" },
                  },
                  [
                    _c("div", {
                      staticClass: "view-points-icon",
                      style:
                        "background: url(" +
                        _vm.userOfferImageUrlForSp +
                        "/ttl_view_point.png) no-repeat center; background-size: contain;",
                      attrs: { "data-test": "viewpoints-icon" },
                    }),
                    _vm._v(" "),
                    _c(
                      "h2",
                      {
                        style:
                          "background: url(" +
                          _vm.userOfferImageUrlForSp +
                          "/view_point_line.png) repeat-x bottom; background-size: 6px;",
                        attrs: { "data-test": "viewpoints-line" },
                      },
                      [_vm._v("\n        女の転職！取材レポート\n      ")]
                    ),
                    _vm._v(" "),
                    _vm.report.name
                      ? _c("div", {
                          staticClass:
                            "report-title fs12 fb view-point-contents",
                          attrs: { "data-test": "viewpoints-name" },
                          domProps: {
                            textContent: _vm._s(
                              "取材担当" + _vm.report.name + "より"
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "view-point-contents pega-pre-wrap",
                      attrs: { "data-test": "viewpoints-body" },
                      domProps: { textContent: _vm._s(_vm.report.body) },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowEnvironment(_vm.environment)
        ? _c("job-preview-data-for-company-sp", {
            attrs: { environment: _vm.environment },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("job-preview-section-title-sp", {
        staticClass: "mt10",
        attrs: { title: "会社概要" },
      }),
      _vm._v(" "),
      _c("company-preview-company-info-sp", {
        staticClass: "mb20",
        attrs: { "company-info": _vm.companyInfo },
      }),
      _vm._v(" "),
      _c("job-preview-section-title-sp", {
        staticClass: "mt10",
        attrs: { title: "募集中の求人情報" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "contents-inner" }, [
        _c("p", { staticClass: "link-type-01 mt5" }, [
          _c(
            "a",
            {
              style:
                "background: url(" +
                _vm.userOfferImageUrlForSp +
                "/icon_arrow_right_red.png) no-repeat left; background-size: 8px 8px;",
              attrs: { "data-test": "recruitment-job-info-text" },
            },
            [
              _vm._v(
                "\n        募集中の求人情報の「職種名」が表示されます。\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("user-preview-menu-sp", {
        attrs: { titles: ["フォトクリップ", "インタビュー"] },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }